import React from 'react';
import { Container } from 'reactstrap';
import { useParams } from 'react-router';
import Edit from './Edit';
import { SlideOverlay } from 'components';
import { useList } from 'utils/useList';
import { Language } from 'interfaces/languages';
import { GET_BIDDER_LIST, UPDATE_BIDDER, newBidder } from 'requests/bidder';

export interface Request {
    getLanguages: Language[];
}
export interface Mutation {
    languageData: Language;
}

function LanguageView() {
    const { id } = useParams<{ id: string }>();
    const list = useList<Request, Language>({
        parent: 'network',
        type: 'bidder',
        request: GET_BIDDER_LIST,
        mutation: UPDATE_BIDDER,
        createItem: newBidder,
        headers: [
            { name: 'name', label: 'Name' },
            { name: 'bidderCode', label: 'bidder Code' },
        ],
    });

    return (
        <Container>
            <h1>Bidders</h1>
            {list}
            {id && (
                <SlideOverlay size='large'>
                    <Edit id={id} />
                </SlideOverlay>
            )}
        </Container>
    );
}

export default LanguageView;
